<template>
  <Teleport to="body">
    <div v-if="open && place" class="fixed inset-0 z-[1100] flex items-center justify-center p-4">
      <div class="absolute inset-0 bg-black/40" @click="close"></div>
      <div class="relative bg-white rounded-[24px] w-full max-w-[360px] p-5 md:p-6">
        <button
          class="absolute top-5 right-5 text-txopacity hover:text-txprimary transition-colors"
          @click="close"
        >
          <Icon name="lucide:x" class="text-xl" />
        </button>

        <div class="text-[14px] font-medium" :style="{ color }">Выбор формата</div>
        <div class="text-[24px] font-bold text-txprimary leading-[1.25] mt-1 pr-8 line-clamp-1">
          {{ place.name }}
        </div>
        <p class="text-[14px] text-txopacity leading-[1.5] mt-2">
          {{ socialLabel }} · выберите формат — цена по прайсу паблишера
        </p>

        <div class="mt-4 flex flex-col gap-2 max-h-[45vh] overflow-y-auto">
          <button
            v-for="(item, i) in sortedPrices"
            :key="item.priceType"
            type="button"
            class="w-full text-left rounded-[16px] border px-4 py-3 flex items-start justify-between gap-3 transition-colors"
            :class="
              selectedIndex === i
                ? 'bg-[#eef3fd] border-[#d9e5ff]'
                : 'bg-white border-[#EEF1F6] hover:border-[#d9e5ff]'
            "
            @click="selectedIndex = i"
          >
            <div class="min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="text-[14px] font-medium text-txprimary">
                  {{ getFormat(item.priceType)[0] }}
                </span>
                <span
                  v-if="i === 0"
                  class="text-[11px] leading-4 text-white rounded-full px-2 py-0.5"
                  :style="{ backgroundColor: color }"
                >
                  Популярно
                </span>
              </div>
              <div class="text-[12px] text-txopacity leading-4 mt-1">
                {{ getFormat(item.priceType)[1] }}
              </div>
            </div>
            <div class="text-[16px] font-bold text-txprimary whitespace-nowrap">
              {{ item.price.toLocaleString() }} ₽
            </div>
          </button>
        </div>

        <button
          class="w-full h-[50px] rounded-[12px] text-white text-[14px] font-medium mt-4 transition-opacity hover:opacity-90 disabled:opacity-40"
          :style="{ backgroundColor: color }"
          :disabled="!sortedPrices.length"
          @click="addToCart"
        >
          Добавить в корзину
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts" setup>
  const props = withDefaults(defineProps<{ open: boolean; place: any; color?: string }>(), {
    color: "#3176FF",
  });
  const emit = defineEmits(["update:open", "add"]);

  const selectedIndex = ref(0);

  watch(
    () => props.open,
    (val) => {
      if (val) selectedIndex.value = 0;
    }
  );

  const priceOrder = ["post24h", "post48h", "post72h", "post30d", "fixedInTop", "repost", "story", "native"];

  const sortedPrices = computed(() =>
    [...(props.place?.prices || props.place?.costs || [])].sort(
      (a, b) => priceOrder.indexOf(a.priceType) - priceOrder.indexOf(b.priceType)
    )
  );

  const socialLabel = computed(() => {
    const s = props.place?.social;
    if (s === "vk") return "ВКонтакте";
    if (s === "max") return "MAX";
    return "Telegram";
  });

  const getFormat = (format: string): string[] => {
    const map: Record<string, string[]> = {
      post24h: ["Пост 24ч", "24 часа в ленте"],
      post48h: ["Пост 48ч", "48 часов в ленте"],
      post72h: ["Пост 72ч", "72 часа в ленте"],
      post30d: ["Пост 30 дней", "30 дней в ленте"],
      fixedInTop: ["Пост 30 дней", "30 дней в ленте"],
      repost: ["Репост", "24 часа в ленте"],
      story: ["История/клип", "Короткий формат с высоким охватом"],
      native: ["Нативный пост", "Рекламная запись в ленте сообщества"],
    };
    return map[format] ?? [format, ""];
  };

  const close = () => emit("update:open", false);

  const addToCart = () => {
    const price = sortedPrices.value[selectedIndex.value];
    if (!price) return;
    emit("add", props.place, price);
    close();
  };
</script>
